export const INDIVIDUAL_ACCESS_INFO =
    'Sharing a quote directly with a user via email or link invitation will add them as a collaborator. Collaborators and quote owners will keep access even if they are removed from a team.'
export const TEAM_ACCESS_INFO =
    'Once a quote has been added to a team, all members will have access to the quote and its contents unless the quote is deleted or removed from the team.'
